import React,{useEffect} from 'react';
import Input from '../../../components/Input/Input';
import { FaTimes } from 'react-icons/fa';
import './AddPromoTextModal.css';

const AddPromoText = ({
  showModal,
  promoText,
  setPromoText,
  saveLoading,
  onSave,
  onClose
}) => {
   useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  if (!showModal) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content add-edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Add Promo Text</h3>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
            disabled={saveLoading}
          >
            <FaTimes />
          </button>
        </div>

        <div className="profile-form">
          <Input
            title="Promo Text"
            type="text"
            placeholder="Enter promo text"
            value={promoText}
            onChange={e => setPromoText(e.target.value)}
          />

          <div className="form-actions">
            <button type="button" onClick={onSave} disabled={saveLoading} aria-busy={saveLoading}>
              {saveLoading ? (
                'Saving...'
              ) : (
                'Save'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPromoText; 